import React from 'react'
import PropTypes from 'prop-types'
import universal from 'react-universal-component'

import Spinner from 'components/Spinner'
import Page from 'layouts/Page'

import styles from './styles.css'

const LoadingScreen = () => <Spinner width={45} height={45} center />

const ErrorScreen = ({ error }) => (
  <Page className={styles.errorPage}>
    {error ? error.message : 'Ett oväntat fel uppstod.'}
  </Page>
)

ErrorScreen.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string.isRequired,
  }),
}

ErrorScreen.defaultProps = {
  error: null,
}

const Universal = universal(
  ({ component, pageType }) => {
    if (pageType === 'static') {
      return import(`static/${component}`)
    } else if (pageType === 'view') {
      return import(`views/${component}/index`)
    }
    return null
  },
  {
    minDelay: 500,
    loading: LoadingScreen,
    error: ErrorScreen,
  },
)

Universal.propTypes = {
  component: PropTypes.string.isRequired,
  pageType: PropTypes.oneOf(['view', 'static']),
}

export default Universal



// WEBPACK FOOTER //
// ../source/components/Universal/index.js